import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { textSM } from '@styles/fonts'
import styled from 'styled-components'

export const SuburbNote = styled.div`
  ${textSM};
  color: ${COLORS.grey[60]};
  padding-bottom: 100px;

  @media ${DEVICES.mobile} {
    padding-bottom: 60px;
  }

  p {
    margin-bottom: 1rem;
  }
`
